<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-12-21 21:11:52
 * @LastEditTime: 2022-03-16 10:25:22
 * @LastEditors: chenguobiao
-->
<template>
  <div class="dialog" v-if="visible">
    <div class="dialog__masker"></div>
    <div class="dialog__box">
      <div class="dialog__tips" v-if="desc">
        <p>
          <img src="@/render/assets/images/personal/icon_service02.png">
        </p>
        <p>{{desc}}</p>
      </div>
      <div class="dialog__info" v-if="contactInfo">
        <p>
          <span class="icon--image"><img src="@/render/assets/images/personal/icon_person.png"/></span><span class="txt">{{contactInfo.name}}</span>
        </p>
        <p>
          <span class="icon--image"><img src="@/render/assets/images/personal/icon_phone.png"/></span><span class="txt">{{contactInfo.phone}}</span>
        </p>
      </div>
      <div class="dialog__close" @click="close">
        <img src="@/render/assets/images/personal/close_service.png">
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from './mixin'
import { personalAPI } from '@/apis'
export default {
  mixins: [dialogMixin],
  props: {
    desc: {
      type: String
    }
  },
  data() {
    return {
      contactInfo: null
    }
  },
  mounted() {
    this.getOneContact()
  },
  methods: {
    async getOneContact() {
      const { data } = await personalAPI.postGetOneContact({
        uid: 1
      })
      this.contactInfo = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./dialog.scss";
.dialog {
  &__box {
    width: val(400);
    z-index: 100;
  }
  &__tips {
    margin-bottom: val(17);
    display: flex;
    align-items: center;
    p {
      &:first-of-type {
        width: val(58);
        height: val(58);
        margin-right: val(12);
      }
      &:last-of-type {
        // padding-left: val(30);
        // width: val(323);
        padding: val(10) 0 val(10) val(30);
        flex: 1;
        min-height: val(64);
        line-height: val(24);
        display: flex;
        align-items: center;
        background: #ECCFAD;
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 0px;
        font-size: val(18);
        color: #502700;
        box-sizing: border-box;
      }
    }

  }
  &__info {
    width: val(400);
    height: val(126);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url(../../assets/images/personal/dialog_bg.png) left top no-repeat;
    background-size: 100%;
    p {
      display: flex;
      align-items: center;
      width: val(240);
      font-size: val(20);
      line-height: val(26);
      color: #502700;
      margin-bottom: val(14);
      &:last-of-type {
        margin-bottom: 0rem;
      }
      .icon--image {
        width: val(24);
        margin-right: val(8);
      }
      .txt {
        flex: 1;
      }
    }
  }
  &__close {
    cursor: pointer;
    margin: val(29) auto 0;
    width: val(42);
    height: val(42);
  }
}

</style>